import { render, staticRenderFns } from "./ClubEditor.vue?vue&type=template&id=2086b452"
import script from "./ClubEditor.vue?vue&type=script&lang=js"
export * from "./ClubEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports